module.exports = __webpack_public_path__ + "img/IMG_2185.a809ce7a.jpg";